<template>
  <v-dialog
    v-model="dialog"
    width="900"
    >
    <v-card
      ref="ticket"
      v-if="payment && dialog"
      rounded="lg"
      >
      <v-card-text
        class="pa-6 text--primary"
        id="ticket"
        >
        <div
          class="d-flex justify-space-between align-center"
          >
          <div
            class="font-weight-bold text-h4"
            >
            Recibo
          </div>

          <div
            class="font-weight-bold text-h6"
            >
            {{ (new Date(payment.paidAt)).toLocaleDateString() }}
          </div>

          <div
            class="font-weight-bold text-h6"
            >
            <v-text-field
              outlined
              solo
              flat
              class="rounded-0 text-h6"
              prefix="$"
              hide-details
              :value="Math.abs(payment.total)"
              ></v-text-field>
          </div>
        </div>

        <div
          class="text-h6"
          >
          <div
            class="mt-3 d-flex align-center"
            style="gap: 8px"
            >
            <span>Recibí de</span>
            <v-text-field
              :value="payment.name"
              class="text-h6 rounded-0"
              solo
              flat
              style="border-bottom: 1px solid black"
              hide-details
              ></v-text-field>
          </div>

          <div
            class="mt-3 d-flex align-center"
            style="gap: 8px"
            >
            <span>la suma de</span>
            <v-text-field
              :value="numeroALetras(Math.abs(payment.total)).toUpperCase()"
              class="text-h6 rounded-0"
              solo
              flat
              style="border-bottom: 1px solid black"
              hide-details
              ></v-text-field>
          </div>

          <div
            class="mt-3 d-flex align-center"
            style="gap: 8px"
            >
            <span>en concepto de</span>
            <v-text-field
              :value="payment.concept"
              class="text-h6 rounded-0"
              solo
              flat
              style="border-bottom: 1px solid black"
              hide-details
              ></v-text-field>
          </div>

          <div
            class="mt-3 d-flex align-start"
            style="gap: 8px"
            >
            <span>Forma de pago:</span>

            <div>
              <v-radio-group 
                hide-details
                class="mt-0 text-h6"
                v-model="payment.paymentType">
                <v-radio
                  v-for="n in ['Efectivo', 'Cheque', 'Transferencia']"
                  :key="n"
                  :label="n"
                  :value="n"
                  ></v-radio>
              </v-radio-group>
            </div>
          </div>

          <div
            class="mt-6 d-flex align-center"
            style="gap: 8px"
            >
            <span>Firma</span>
            <v-text-field
              class="text-h6 rounded-0"
              solo
              flat
              style="border-bottom: 1px solid black"
              hide-details
              ></v-text-field>
          </div>
        </div>
      </v-card-text>

      <v-card-actions
        class="justify-end"
        >
        <v-btn
          text
          color="primary"
          @click="printPdf"
          >
          Descargar Recibo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Payment } from '@/graphql/queries/payment'
import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf"

export default {
  data: () => ({
    dialog: false,
    payment: null
  }),

  props: {
    id: {
      type: String | Number,
      required: true
    }
  },

  created () {
    this.fetchPayment()
  },

  methods: {
    fetchPayment () {
      this.$apollo.query({
        query: Payment,
        variables: {
          id: this.id
        }
      }).then ( res => {
        this.payment = res.data.payment
      })
    },

    printPdf () {
      const ticket = document.getElementById("ticket")
      html2canvas(ticket, { useCORS: true, width: ticket.clientWidth, height: ticket.clientHeight }).then(canvas => {
        var img = canvas.toDataURL("image/png");

        var doc = new jsPDF(
          'l',
          'px',
          [ticket.clientWidth, ticket.clientHeight]
        );

        doc.addImage(img, 'png', 0, 0, ticket.clientWidth, ticket.clientHeight);
        doc.save(`recibo_${this.payment.id}.pdf`);
      })
    },

    unidades(num){
      switch(num)
      {
        case 1: return "UN";
        case 2: return "DOS";
        case 3: return "TRES";
        case 4: return "CUATRO";
        case 5: return "CINCO";
        case 6: return "SEIS";
        case 7: return "SIETE";
        case 8: return "OCHO";
        case 9: return "NUEVE";
      }

      return "";
    },
    //Unidades()

    decenas(num){

      var decena = Math.floor(num/10);
      var unidad = num - (decena * 10);

      switch(decena)
      {
        case 1:
          switch(unidad)
          {
            case 0: return "DIEZ";
            case 1: return "ONCE";
            case 2: return "DOCE";
            case 3: return "TRECE";
            case 4: return "CATORCE";
            case 5: return "QUINCE";
            default: return "DIECI" + this.unidades(unidad);
          }
        case 2:
          switch(unidad)
          {
            case 0: return "VEINTE";
            default: return "VEINTI" + this.unidades(unidad);
          }
        case 3: return this.decenasY("treinta", unidad);
        case 4: return this.decenasY("cuarenta", unidad);
        case 5: return this.decenasY("cincuenta", unidad);
        case 6: return this.decenasY("sesenta", unidad);
        case 7: return this.decenasY("setenta", unidad);
        case 8: return this.decenasY("ochenta", unidad);
        case 9: return this.decenasY("noventa", unidad);
        case 0: return this.unidades(unidad);
      }
    },//Unidades()

    decenasY(strSin, numUnidades) {
      if (numUnidades > 0)
        return strSin + " Y " + this.unidades(numUnidades)

      return strSin;
    },//DecenasY()

    centenas(num) {
      var centenas = Math.floor(num / 100);
      var decenas = num - (centenas * 100);

      switch(centenas)
      {
        case 1:
          if (decenas > 0)
            return "CIENTO " + this.decenas(decenas);
          return "CIEN";
        case 2: return "DOSCIENTOS " + this.decenas(decenas);
        case 3: return "TRESCIENTOS " + this.decenas(decenas);
        case 4: return "CUATROCIENTOS " + this.decenas(decenas);
        case 5: return "QUINIENTOS " + this.decenas(decenas);
        case 6: return "SEISCIENTOS " + this.decenas(decenas);
        case 7: return "SETECIENTOS " + this.decenas(decenas);
        case 8: return "OCHOCIENTOS " + this.decenas(decenas);
        case 9: return "NOVECIENTOS " + this.decenas(decenas);
      }

      return this.decenas(decenas);
    },//Centenas()

    seccion(num, divisor, strSingular, strPlural) {
      var cientos = Math.floor(num / divisor)
      var resto = num - (cientos * divisor)

      var letras = "";

      if (cientos > 0)
        if (cientos > 1)
          letras = this.centenas(cientos) + " " + strPlural;
      else
        letras = strSingular;

      if (resto > 0)
        letras += "";

      return letras;
    },//Seccion()

    miles(num) {
      var divisor = 1000;
      var cientos = Math.floor(num / divisor)
      var resto = num - (cientos * divisor)

      var strMiles = this.seccion(num, divisor, "UN MIL", "MIL");
      var strCentenas = this.centenas(resto);

      if(strMiles == "")
        return strCentenas;

      if (strCentenas)
        return strMiles + " " + strCentenas;

      return strMiles
    },//Miles()

    millones(num) {
      var divisor = 1000000;
      var cientos = Math.floor(num / divisor)
      var resto = num - (cientos * divisor)

      var strMillones = this.seccion(num, divisor, "UN MILLON DE", "MILLONES DE");
      var strMiles = this.miles(resto);

      if(strMillones == "")
        return strMiles;

      return strMillones + " " + strMiles;
    },//Millones()

    numeroALetras(num) {
      var data = {
        numero: num,
        enteros: Math.floor(num),
        centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
        letrasCentavos: "",
        letrasMonedaPlural: 'Pesos',//"PESOS", 'Dólares', 'Bolívares', 'etcs'
        letrasMonedaSingular: 'Peso', //"PESO", 'Dólar', 'Bolivar', 'etc'

        letrasMonedaCentavoPlural: "CENTAVOS",
        letrasMonedaCentavoSingular: "CENTAVO"
      };

      if (data.centavos > 0) {
        data.letrasCentavos = "CON " + (function (){
          if (data.centavos == 1)
            return this.millones(data.centavos) + " " + data.letrasMonedaCentavoSingular;
          else
            return this.millones(data.centavos) + " " + data.letrasMonedaCentavoPlural;
        })();
      };

      if(data.enteros == 0)
        return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
      if (data.enteros == 1)
        return this.millones(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
      else
        return this.millones(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
    }
  }
}
</script>
